import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import { startLoading, stopLoading } from "../../../Actions/General/LayoutActions";
import { updateQuickMenu } from "../../../Actions/Users/UserActions";
import Button from "../../../Common/Buttons/Button";
import PopupManager from "../../../Common/Popups/PopupManager";
import { determineDataSource } from "../../../Data/DataStores/DataSource";
import { type RootState } from "../../../Reducers/ShopfrontReducers";
import Request from "../../../Utilities/Platform/Request";

const connector = connect((state: RootState) => ({
    user: state.user.id,
}));

type PropsFromRedux = ConnectedProps<typeof connector> & {
    dispatch: ThunkDispatch<any, any, any>;
};

interface Props extends PropsFromRedux {
    url: string;
}

type State = {
    name: string;
};

export class QuickMenuAdd extends React.Component<Props, State> {
    public state = {
        name: "",
    };

    public onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const name = e.currentTarget.name as keyof State;
        const value = e.currentTarget.value;

        this.setState({
            [name]: value,
        });
    };

    public onCancel = (): void => {
        this.props.dispatch(hideDialog());
    };

    public onAdd = (e: React.MouseEvent<HTMLButtonElement>): Promise<void> => {
        e.stopPropagation();

        if(!this.props.user) {
            return Promise.resolve();
        }

        const user = this.props.user;

        if(!this.state.name.trim()) {
            PopupManager.error("Please enter a valid name.");

            return Promise.resolve();
        }

        this.props.dispatch(hideDialog());
        this.props.dispatch(startLoading());

        return Request.post("/graphql", {
            query: `
                mutation AddQuickMenuItem($user: ID!, $name: String!, $url: String!) {
                    addQuickMenuItem(user: $user, name: $name, url: $url) {
                        id,
                        url,
                        name,
                        external
                    }
                } 
            `,
            variables: {
                url : this.props.url,
                user: user,
                name: this.state.name.trim(),
            },
        })
            .then(response => {
                if(response.data.error) {
                    throw response.data.error;
                }

                const quickMenu = response.data.data.addQuickMenuItem;

                determineDataSource()
                    .then(source => {
                        return source.users.update(user, {
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            quick_menu: quickMenu,
                        });
                    })
                    .catch(err => {
                        console.error("Error updating local user's quick menu", err);
                    });

                this.props.dispatch(updateQuickMenu(quickMenu));
            })
            .catch(err => {
                PopupManager.error("Failed to add quick menu item");
                console.error("Error adding quick menu item", err);
            })
            .then(() => {
                this.props.dispatch(stopLoading());
            });
    };

    public render(): React.ReactNode {
        return (
            <div className="quick-menu-add">
                <p>What should the name of the quick menu item?</p>
                <label>
                    Name
                    <input
                        autoFocus
                        name="name"
                        value={this.state.name}
                        onChange={this.onChange}
                    />
                </label>
                <div className="buttons">
                    <Button
                        classes={[ "button-cancel" ]}
                        onClick={this.onCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        classes={[ "button-add" ]}
                        onClick={this.onAdd}
                    >
                        Add
                    </Button>
                </div>
            </div>
        );
    }
}

export default connector(QuickMenuAdd);
